import React, { lazy, Suspense, useState, useEffect, useRef,useCallback } from "react";
import FetchHook from "./useFetchHook";
import config from './moduleMap'
import loadable from '@loadable/component'
import Spinner from "../client/components/spinner";
import {ErrorBoundary} from 'react-error-boundary'
import logger from "./logger";

const loadableCache = {};
function getLoadableComponent(moduleMap) {
  if (!loadableCache[moduleMap]) {
    loadableCache[moduleMap] = loadable(() => import(`./modules/${moduleMap}`), { ssr: true });
  }
  return loadableCache[moduleMap];
}

export const Modules = (props) => {
    const siteConfig = props && props.siteConfig
    const [loading, setLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [newModules, setNewModules] = useState([]);
    const pagedata = props.pagedata
    const offset = props.offset;
  

    const loadData = function () {
        setLoading(true)
        loadNextComponents();
      };
    
      const isBottomOfPage = () => {
        if( typeof window !== "undefined"){ 
          const windowHeight = window.innerHeight;
          const body = window.document.body;
          const html = window.document.documentElement;
          const docHeight = Math.max(
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          const windowBottom = windowHeight + window.pageYOffset + 300;
          return windowBottom >= (docHeight);
        }
        else return
      };
    
      const handleScroll =(event) => {
        event && event.preventDefault();
        if (isBottomOfPage() && offset < props.moduleCount && !loading) {
          loadData();
        }
      }

      const callHandleScroll = debounce(handleScroll, 50);

      const checkScroll = function (e) {
        callHandleScroll();
      };

      function debounce(func, timeout){
        let timer;
        return (...args) => {
          if (!timer) {
            func.apply(this, args);
          }
          clearTimeout(timer);
          timer = setTimeout(() => {
            timer = undefined;
          }, timeout);
        };
      }
  

      useEffect(() => {
        if(offset >= props.moduleCount){
          return
        }
    
          ['wheel', 'touchmove', 'scroll'].forEach((e) => {
              if( typeof window !== "undefined"){
                  window.addEventListener(e, checkScroll, {
                    passive: false,
                });
              }
            });
    
    
        return () => {
          ['wheel', 'touchmove', 'scroll'].forEach((e) => {
            if( typeof window !== "undefined" || offset >= props.moduleCount){
              window.removeEventListener(e, checkScroll);
            }
          });
        };
      }, [pagedata]);
    
      const loadNextComponents =  () => {
        let limit = props.moduleCount - props.offset >= 4 ? 4 : props.moduleCount - props.offset
        FetchHook({offset:props.offset,limit:limit})
        .then((res) => {
              const newModuleData = res?.data?.data?.page?.modules;
              if (newModuleData.length) {
                setNewModules(newModuleData);
                setLoading(false);
                setHasLoaded(true);
              } else {
                setHasLoaded(false);
                setLoading(false);
              }
              ['wheel', 'touchmove', 'scroll'].forEach((e) => {
                if( typeof window !== "undefined"){
                  window.removeEventListener(e, checkScroll);
                }  
              });
            
            
          })
          .catch((e)=> {
            logger(`Error fetching modules: ${e}`, "error");
          })
      };
    return(<>
            {hasLoaded && newModules.length ? newModules.map((module, index) => {
                let moduleMap = module?.layout?.view ? config.map[module.layout.view] : null
                if (!moduleMap) {
                    return logger(`Module not found for '${moduleMap}'`)
                }
                let Component = getLoadableComponent(moduleMap);
            return(
                <div key={module.id}>
                  <ErrorBoundary fallback={<p>Something went Wrong..</p>}>
                    <Suspense>
                        {Component && <Component siteConfig={siteConfig} moduleData={module}/>}
                    </Suspense>
                  </ErrorBoundary>  
                </div>
            )
            }) : <></> }
            {loading && <div className="module-loader-spinner"><Spinner /></div>}
            {hasLoaded && newModules.length ? <Modules  siteConfig={siteConfig} offset={offset + 4} moduleCount={props.moduleCount} pagedata={pagedata}/>:<></>}
            </>
        
    )
}

export default Modules
